import * as React from "react";
import {UploadOdd} from "../odd-iq/UploadOdd";
import {withVerifyAccess} from "../common/withVerifyAccess";
import {UserTypeEnum} from "../../model/UserInfo.model";

export const AdminUploadPage: React.FunctionComponent = () => {
    return <div className="page-container new-common-styles admin-upload-page__content main-content">
        <h1>Admin Upload</h1>
        <p className="admin-upload-page__subtitle">Manage system data uploads and configurations.</p>
        <UploadOdd/>
    </div>;
};

export default withVerifyAccess(AdminUploadPage, UserTypeEnum.ADMIN);
